(() => {
  const STORAGE_PREFIX = 'se-collection-image-view:';
  const VALID_VIEWS = new Set(['primary', 'secondary']);

  const readStoredView = (key) => {
    try {
      const value = window.sessionStorage.getItem(key);
      return VALID_VIEWS.has(value) ? value : null;
    } catch (error) {
      return null;
    }
  };

  const storeView = (key, view) => {
    try {
      window.sessionStorage.setItem(key, view);
    } catch (error) {
      // Storage can be unavailable in private browsing; the switcher still works.
    }
  };

  const initialiseSection = (section) => {
    if (!section || section.dataset.imageSwitcherInitialised === 'true') return;

    const controls = section.querySelector('[data-image-switcher-controls]');
    if (!controls) return;

    const buttons = Array.from(controls.querySelectorAll('[data-image-view]'));
    if (buttons.length === 0) return;

    const defaultView = VALID_VIEWS.has(section.dataset.defaultView)
      ? section.dataset.defaultView
      : 'primary';
    const storageKey = `${STORAGE_PREFIX}${window.location.pathname}`;

    const setView = (view, persist = true) => {
      const safeView = VALID_VIEWS.has(view) ? view : defaultView;

      section.classList.toggle('collection-image-view--primary', safeView === 'primary');
      section.classList.toggle('collection-image-view--secondary', safeView === 'secondary');
      section.dataset.currentImageView = safeView;

      buttons.forEach((button) => {
        const isActive = button.dataset.imageView === safeView;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      if (persist) storeView(storageKey, safeView);
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => setView(button.dataset.imageView));
    });

    section.dataset.imageSwitcherInitialised = 'true';
    setView(readStoredView(storageKey) || defaultView, false);
  };

  const initialiseAll = (scope = document) => {
    if (scope.matches?.('[data-collection-image-switcher-section]')) {
      initialiseSection(scope);
    }
    scope.querySelectorAll?.('[data-collection-image-switcher-section]').forEach(initialiseSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
